import dayjs from 'dayjs';

export const getDeliveryWeek = (
  availabilityWeek?: number | null,
  availabilityYear?: number | null,
  estimatedDeliveryDate?: Date | null,
) => {
  if (!availabilityWeek || !availabilityYear || !estimatedDeliveryDate) {
    return { deliveryWeek: undefined, deliveryYear: undefined };
  }

  const availabilityDate = dayjs()
    .year(availabilityYear)
    .week(availabilityWeek);
  const deliveryDate = estimatedDeliveryDate
    ? dayjs(estimatedDeliveryDate)
    : availabilityDate;

  const deliveryWeek = deliveryDate.week();
  const deliveryYear = deliveryDate.year();

  return {
    deliveryWeek,
    deliveryYear,
    differenceInWeeks: deliveryDate.diff(availabilityDate, 'week'),
    availabilityDate,
  };
};
